import { Controller } from "@hotwired/stimulus";
import axios from "axios";

export default class extends Controller {
  static targets = ["input", "results"];
  static values = { searchUrl: String, linkUrl: String };

  connect() {
    this.debounceTimer = null;
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  onInput() {
    clearTimeout(this.debounceTimer);
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }
    this.debounceTimer = setTimeout(() => this.search(query), 300);
  }

  async search(query) {
    try {
      const { data } = await axios.get(this.searchUrlValue, {
        params: { q: query },
      });
      this.showResults(data);
    } catch (error) {
      this.resultsTarget.classList.add("hidden");
    }
  }

  showResults(enseignes) {
    if (!enseignes || enseignes.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="px-4 py-3 text-sm text-gray-500">Aucune enseigne trouvée</div>
      `;
      this.resultsTarget.classList.remove("hidden");
      return;
    }

    this.resultsTarget.innerHTML = enseignes
      .slice(0, 10)
      .map(
        (e) => `
        <button type="button"
                class="w-full text-left px-4 py-2.5 hover:bg-blue-50 flex items-center justify-between text-sm transition-colors"
                data-action="click->franchise-link#select"
                data-enseigne-id="${e.id}"
                data-enseigne-name="${this.escapeHtml(e.name || "")}">
          <span class="font-medium text-gray-900">${this.escapeHtml(e.name || "Sans nom")}</span>
          <span class="text-xs text-gray-400">#${e.id}</span>
        </button>
      `,
      )
      .join("");
    this.resultsTarget.classList.remove("hidden");
  }

  select(event) {
    const enseigneId = event.currentTarget.dataset.enseigneId;
    this.resultsTarget.classList.add("hidden");
    this.inputTarget.value = "";

    // Submit via a form POST
    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.linkUrlValue;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "authenticity_token";
      tokenInput.value = csrfToken;
      form.appendChild(tokenInput);
    }

    const idInput = document.createElement("input");
    idInput.type = "hidden";
    idInput.name = "enseigne_id";
    idInput.value = enseigneId;
    form.appendChild(idInput);

    document.body.appendChild(form);
    form.submit();
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.resultsTarget.classList.add("hidden");
    }
  }

  escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }
}
